import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-gamepad-line text-lg text-white"></i>
              </span>
              <span className="font-heading text-lg text-background-50">PG模拟器</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              PG模拟器是专为游戏爱好者打造的在线模拟体验平台，无需下载即可免费试玩PG系列游戏。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/jingdian" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">游戏分类</Link>
              <Link to="/article/pg-monitiqi-xinshou-gonglue" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">文章资讯</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/category/jingdian" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">经典老虎机</Link>
              <Link to="/category/dongman" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">动漫主题</Link>
              <Link to="/category/shenhua" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">神话传说</Link>
              <Link to="/category/maoxian" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">冒险探索</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">联系方式</h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-background-400">
                <i className="ri-mail-line mr-2"></i>support@pg-simulator.com
              </span>
              <span className="text-sm text-background-400">
                <i className="ri-phone-line mr-2"></i>400-888-6666
              </span>
              <span className="text-sm text-background-400">
                <i className="ri-map-pin-line mr-2"></i>北京市朝阳区科技园区
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/30 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 PG模拟器 版权所有 | pg模拟器官网入口
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="/about" className="hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">隐私政策</a>
            <a href="/about" className="hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">服务条款</a>
            <a href="/about" className="hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}